<template>
    <div id="alert-view">
      <mt-popup v-model="show" :closeOnClickModal="0" class="alert-popup">
        <div class="header">温馨提示<div class="closebtn" @click="closeBtn(-1)"></div></div>
        <div class="title" v-show="title.length>0">{{title}}</div>
        <div class="subTitle" v-show="subTitle.length>0">{{subTitle}}</div>
        <div class="footer">
          <div class="sureBtn" @click="sureClick(1)">{{sureTitle}}</div>
          <div class="cancelBtn" @click="cancelClick(0)">{{cancelTitle}}</div>
        </div>
      </mt-popup>
    </div>
</template>

<script>
export default {
  props: {
    show: false,
    title: '',
    subTitle: '',
    cancelTitle: '',
    sureTitle: '' // 底部单一 按钮
  },
  data () {
    return {
    }
  },
  methods: {
    closeBtn: function (index) {
      this.$emit('alertViewClick', index)
    },
    cancelClick: function (index) {
      // 取消
      this.$emit('alertViewClick', index)
    },
    sureClick: function (index) {
      // this.show = false
      this.$emit('alertViewClick', index)
    }
  }
}
</script>

<style scoped>
  .alert-popup{
    position: center;
    width: 90%;
    /*height: 200px;*/
    min-height: 100px;
    border-radius: 3px;
    overflow: hidden;
  }
  .alert-popup .header{
    width: 100%;
    padding-left: 20px;
    height: 45px;
    line-height: 45px;
    background-color: #c41335;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: bold;
  }
  .closebtn{
    position: absolute;
    top: 12px;
    right: 12px;
    height: 20px;
    width: 20px;
    /*background-color: yellow;*/
    background-image: url("../assets/icon-close-w.png");
    background-position: center center;
    background-size: cover;
  }
  .alert-popup .title{
    width: 100%;
    margin-top: 20px;
    height: 20px;
    line-height: 20px;
    color: #323232;
    font-size: 16px;
    text-align: center;
  }
  .alert-popup .subTitle{
    margin: 20px;
    max-height: 50px;
    line-height: 25px;
    color: #323232;
    font-size: 15px;
    text-align: center;
  }
  .alert-popup .footer{
    position: relative;
    height: 40px;
    margin: 25px 15px 20px 15px;
  }
  .alert-popup .footer .sureBtn{
    position: absolute;
    top: 0px;
    /*right: 10px;*/
    left: calc(50% + 8px);
    width: 80px;
    height: 35px;
    line-height: 35px;
    background-color: #c41335;
    color: #ffffff;
    font-size: 15px;
    text-align: center;
    border-radius: 3px;
  }
  .alert-popup .footer .cancelBtn{
    position: absolute;
    top: 0px;
    left: calc(50% - 88px);
    /*right: 105px;*/
    /*max-width: 130px;*/
    /*min-width: 80px;*/
    width: 80px;
    height: 35px;
    line-height: 35px;
    background-color: #FFFFFF;
    color: #aaaaaa;
    font-size: 15px;
    text-align: center;
    border-radius: 3px;
    border: solid 1px #DDDDDD;
    box-sizing: border-box;
  }
  /*.alert-popup .footer .sureBtn2{*/
  /*  position: center;*/
  /*  top: 0px;*/
  /*  margin: 0 auto;*/
  /*  width: 130px;*/
  /*  height: 40px;*/
  /*  line-height: 40px;*/
  /*  background-color: #c41335;*/
  /*  color: #ffffff;*/
  /*  font-size: 15px;*/
  /*  text-align: center;*/
  /*  border-radius: 3px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/alert-view.vue